import { Translate } from '@change-corgi/core/react/i18n';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { PetitionActivityLink } from 'src/app/pages/starterDashboardV2/shared/components';

import { ExportButton } from '../../shared/ExportButton';
import { useExportButton } from '../../shared/ExportButton/hooks/useExportButton';
import { ExportNotifications } from '../components/ExportNotifications';
import { PageBody } from '../components/PageBody';

export const Layout: React.FC<Props> = ({ setCommentsVisibility }) => {
	const { data, actions } = useExportButton('comments');
	const {
		data: {
			petition: { slug },
			featureConfigs: { starterExperiencePetitionActivity: starterExperiencePetitionActivityFCM },
		},
	} = useStarterDashboardV2PageData();

	return (
		<section className="flex max-h-[441px] min-h-fit w-full flex-col bg-background-base px-4 pb-0 pt-8 md:p-12 md:pb-0">
			<div
				className="relative flex w-full flex-col overflow-hidden bg-white"
				data-qa="starter-dashboard-comments-card-new"
				data-testid="starter-dashboard-comments-card-new"
				aria-label="export-comments-card-new"
				aria-describedby="export-comments-card-new"
			>
				{/* Header Section */}
				<div
					id="petition-comments-card-header"
					className="flex items-center justify-between gap-4 pb-[1px]"
					data-testid="comments-header-new"
				>
					<div data-testid="comments-title-container-new">
						<h3
							className="wrap-anywhere font-sans text-size-heading-small text-typography-strong"
							id="comments-card-header-new"
							data-qa="comments-card-header-heading-new"
							data-testid="comments-card-header-heading-new"
							aria-label="export-comments-header-heading-new"
							aria-describedby="export-comments-header-heading-new"
						>
							<Translate value="corgi.petition.starter_dashboard.petition_comments.card.header" />
						</h3>
					</div>
					<div className="ml-auto justify-self-end" data-testid="comments-export-container-new">
						{starterExperiencePetitionActivityFCM ? (
							<PetitionActivityLink slug={slug} linkType="comments" />
						) : (
							<ExportButton
								data-qa="export-signatures-button-new"
								aria-label="export-comments-button-new"
								aria-describedby="export-comments-button-new"
								exportType="COMMENTS"
								data={data}
								actions={actions}
								data-testid="export-comments-button-new"
							/>
						)}
					</div>
				</div>

				{/* Comments Body */}
				<div data-testid="comments-body-new">
					<PageBody setCommentsVisibility={setCommentsVisibility} />
				</div>
				<ExportNotifications data={data} data-testid="comments-export-notifications-new" />
			</div>
		</section>
	);
};

type Props = Readonly<{
	setCommentsVisibility: (visible: boolean) => void;
}>;
